/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'stackedGraph': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#svgicon_stackedGraph_a)" _fill="#686a7a"><path pid="0" d="M5 19V3.001H3V21h18v-2H5Z"/><path pid="1" d="M20 6.001h-4V18h4V6.001ZM15 12h-4v6h4v-6ZM10 10H6v8h4v-8Z"/></g><defs><clipPath id="svgicon_stackedGraph_a"><path pid="2" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
